import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { RefundType } from '../enums/refund-type';
import { RefundTypeProviderService } from '../providers';

@Pipe({
  name: 'refundType',
})
export class RefundTypePipe implements PipeTransform {
  private readonly provider = inject(RefundTypeProviderService);

  public transform(type: RefundType): Observable<string> {
    return this.provider.labelFor(type);
  }
}
